// Mirrors aws-lambda/shared/snowScore.mjs — keep both in sync (see CLAUDE.md).

function newSnowPoints(newSnowInches) {
  const n = Number(newSnowInches) || 0;
  if (n >= 18) return 45;
  if (n >= 12) return 38;
  if (n >= 7) return 30;
  if (n >= 4) return 20;
  if (n >= 1) return 10;
  return 0;
}

function baseDepthPoints(baseDepthInches) {
  if (baseDepthInches === null || baseDepthInches === undefined) return null;
  const n = Number(baseDepthInches);
  if (!Number.isFinite(n)) return null;
  if (n >= 80) return 35;
  if (n >= 60) return 30;
  if (n >= 40) return 22;
  if (n >= 20) return 12;
  return 0;
}

export function windHoldRiskFromMph(windSpeedMph) {
  const w = Number(windSpeedMph) || 0;
  if (w >= 45) return "high";
  if (w >= 35) return "summit";
  if (w >= 25) return "upper_mtn";
  if (w >= 15) return "breezy";
  return "clear";
}

const WIND_HOLD_PENALTY = {
  clear: 0,
  breezy: 8,
  upper_mtn: 20,
  summit: 32,
  high: 40,
};

export const WIND_HOLD_LABELS = {
  clear: "Clear",
  breezy: "Breezy",
  upper_mtn: "Upper mtn hold risk",
  summit: "Summit hold risk",
  high: "Widespread hold risk",
};

export function computeSnowScoreRaw(conditions, resortProfile) {
  let score = 20;

  score += newSnowPoints(conditions.newSnowInches);

  const basePts = baseDepthPoints(conditions.baseDepthInches);
  score += basePts === null ? -5 : basePts;

  const wind = Number(conditions.windSpeedMph) || 0;
  const riskTier = windHoldRiskFromMph(wind);
  score -= WIND_HOLD_PENALTY[riskTier];

  if (resortProfile?.windExposed && wind >= 25) score -= 5;

  return Math.max(0, Math.min(100, score));
}

export function scoreLabelFromScore(score) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  if (s >= 80) return "Powder day";
  if (s >= 60) return "Good day";
  if (s >= 40) return "Fair day";
  if (s >= 20) return "Rough day";
  return "Not worth it";
}

function scoreColorFromScore(score) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  if (s >= 80) return "#38bdf8";
  if (s >= 60) return "#2f8f52";
  if (s >= 40) return "#a3690f";
  if (s >= 20) return "#c53a30";
  return "#7a1f1f";
}

export function calcSnowScore(conditions, resortProfile) {
  const score = computeSnowScoreRaw(conditions, resortProfile);
  return {
    score,
    label: scoreLabelFromScore(score),
    color: scoreColorFromScore(score),
    windHoldRisk: windHoldRiskFromMph(conditions.windSpeedMph),
  };
}
